import React from 'react';
import styled from 'styled-components';
import { GroupMemberContentMode } from '../../shared/enum/EnumRepository';
import { useGroupMemberContentModeStore } from '../../shared/store/groupMemberContentModeStore';
import GroupLabelStation from './GroupLabelStation';
import MobileConvertWrapper from '../../shared/component/MobileConvertWrapper';
import GroupMemberTopBarMobile from './mobile/GroupMemberTopBarMobile';

const GroupMemberTopBar: React.FC = () => {
  const groupMemberContentMode = useGroupMemberContentModeStore((s) => s.groupMemberContentMode);
  const setGroupMemberContentMode = useGroupMemberContentModeStore((s) => s.setGroupMemberContentMode);

  return (
    <TopBar>
      <GroupLabelStation />
      <MobileConvertWrapper
        onlyMobileChildren={<GroupMemberTopBarMobile />}
        onlyNotMobileChildren={
          <LanguageSelector>
            <LanguageOption
              type="button"
              $isActive={groupMemberContentMode === GroupMemberContentMode.Orig}
              onClick={() => setGroupMemberContentMode(GroupMemberContentMode.Orig)}
            >
              Orig
            </LanguageOption>
            <LanguageDivider>/</LanguageDivider>
            <LanguageOption
              type="button"
              $isActive={groupMemberContentMode === GroupMemberContentMode.ENG}
              onClick={() => setGroupMemberContentMode(GroupMemberContentMode.ENG)}
            >
              ENG
            </LanguageOption>
          </LanguageSelector>
        }
      />
    </TopBar>
  );
};

export default GroupMemberTopBar;

const TopBar = styled.div`
  width: 100%;
  height: calc(10vh);
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 5vw;
  margin-bottom: 0.5vh;
`;

const LanguageSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const LanguageOption = styled.button<{ $isActive: boolean }>`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.color_Gray_04 : theme.colors.color_Gray_05};
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.color_Gray_04};
  }
`;

const LanguageDivider = styled.span`
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  user-select: none;
`;
